module.exports = "/work-site/img/car_icon.2e97e97d.gif";